import { render, staticRenderFns } from "./I18nUpdater.vue?vue&type=template&id=14bde55c&"
import script from "./I18nUpdater.vue?vue&type=script&lang=js&"
export * from "./I18nUpdater.vue?vue&type=script&lang=js&"
import style0 from "./I18nUpdater.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "I18nUpdater.vue"
export default component.exports